const userkey = "user"
const agentkey = "agent"
const brandstorekey = "brandstore"
const redirectloginkey = "redirectlogin"

const logintypekey = "logintype"
const LoginTypeAgent = "agent"
const LoginTypeGroup = "group"

const superpermssion = ["index","customer","customer_agent","customer_group","customer_store","guidscreen","app"];
const subagentpermssion = ["index","customer","customer_agent","customer_group","customer_store","guidscreen"];
const grouppermssion = ["index","customer","customer_store","guidscreen"];


function setUser(user){
    sessionStorage.setItem(userkey,JSON.stringify(user));
}


function getUser(){
    return JSON.parse(sessionStorage.getItem(userkey) || "{}");
}

function getUid(){
    var user = getUser();
   return (user && user.uid) ? user.uid :0
}


function setAgent(agent){
    sessionStorage.removeItem(agentkey); 
    sessionStorage.removeItem(brandstorekey); 
    sessionStorage.setItem(agentkey,JSON.stringify(agent));
}

function getAgent(){
    return JSON.parse(sessionStorage.getItem(agentkey) || "{}");
}

function getAgentid(){
   var agent = getAgent();
   return (agent && agent.agentid) ? agent.agentid :0
}

function getAgentcoin(){
   var agent = getAgent();
   return (agent && agent.coin) ? agent.coin :0
}

function getAgentcoinshow(){
   var coin = getAgentcoin();
   return coin ? coin/100:0
}

function fromtotypes(){
    return {
        SubAgent:200,
        Brand:300,
    }
}


function getAgentNow(that,successCallBack){
    that.httputil.post({
       that:that,
       url:that.api.getcurrentagent,
       req:{},
       xmsuccess:function(res){
           if(res.agent){
               setAgent(res.agent)
               if(successCallBack){successCallBack(res);}
           }
       },
       xmfail: function (res) {
          setRedirectLogin();
        //    that.$router.push('login');
            that.$emit('showDetail',false);
       }   
   });
}

function getAccountNow(that,successCallBack){
    let req = {
        sid:3,
        typename: isLoginTypeGroup() ? 'groupadmin' :'agentadmin',
    }
    that.httputil.post({
        url:that.api.getaccount,
        req:req,
        xmsuccess:function(res){
            if(res.user){
                that.user = res.user;
                setUser(res.user);
                if(successCallBack){successCallBack(res)};
            }
        },
        xmfail: function (res) {
            setRedirectLogin();
            // that.$router.push('login');
            that.$emit('showDetail',false);
        }   
    });
}

function setLoginTypeAgent(){
    localStorage.setItem(logintypekey,LoginTypeAgent);
}

function isLoginTypeAgent(){
    return LoginTypeAgent == localStorage.getItem(logintypekey) ? true :false;
}

function setLoginTypeGroup(){
    localStorage.setItem(logintypekey,LoginTypeGroup);
}

function isLoginTypeGroup(){
    return LoginTypeGroup == localStorage.getItem(logintypekey) ? true :false;
}

function setBrandStore(brandstore){
    sessionStorage.removeItem(agentkey); 
    sessionStorage.removeItem(brandstorekey);
    sessionStorage.setItem(brandstorekey,JSON.stringify(brandstore));
}

function getBrandStore(){
    return JSON.parse(sessionStorage.getItem(brandstorekey) || "{}");
}

function getBid(){
    var brandstore = getBrandStore();
   return (brandstore && brandstore.bid) ? brandstore.bid :0
}

function isSuper(){
   return  getAgentid() && 1==getAgent().level &&  1000==getAgent().propstype
}

function isSubAgent(){
   return  getAgentid() && getAgent().level>1
}

function isGroup(){
   return  getBid() 
}


function setRedirectLogin(){
   return  localStorage.setItem(redirectloginkey,"1");
}

function isRedirectLogin(){
   return "1"==localStorage.getItem(redirectloginkey) ? true :false;
}
function clearRedirectLogin(){
    localStorage.removeItem(redirectloginkey); 
}

function checkPermission(code){
    if(isSuper()){
        return arrcontain(superpermssion,code);
    }
    if(isSubAgent()){
        return arrcontain(subagentpermssion,code);
    }
    if(isGroup()){
        return arrcontain(grouppermssion,code);
    }
    return false

}

function arrcontain(arr,code){
    for(var i=0;i<arr.length;i++){
        if(code==arr[i]){return true}
    }
    return false
}



module.exports = {
    setUser: setUser,
    getUser: getUser,
    getUid: getUid,
    setAgent:setAgent,
    getAgent:getAgent,
    getAgentNow:getAgentNow,
    getAgentid:getAgentid,
    getAgentcoin:getAgentcoin,
    getAgentcoinshow:getAgentcoinshow,
    fromtotypes:fromtotypes,
    getAccountNow:getAccountNow,
    setLoginTypeAgent:setLoginTypeAgent,
    isLoginTypeAgent:isLoginTypeAgent,
    setLoginTypeGroup:setLoginTypeGroup,
    isLoginTypeGroup:isLoginTypeGroup,
    setBrandStore:setBrandStore,
    getBrandStore:getBrandStore,
    getBid:getBid,
    isSuper:isSuper,
    isSubAgent:isSubAgent,
    isGroup:isGroup,
    checkPermission:checkPermission,
    setRedirectLogin:setRedirectLogin,
    isRedirectLogin:isRedirectLogin,
    clearRedirectLogin:clearRedirectLogin,
};



//////////////////
// WEBPACK FOOTER
// ./static/js/accountutil.js
// module id = k8NT
// module chunks = 1